import { useState, useRef, useEffect } from "react";
import { Box, Typography, Grid, Button, TextField } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";
import DevicePreview from "./DevicePreview";
import { httpRequest } from "../../../../ui-utils/api";
import { apiUrl, backendHosts } from "../../../../ui-utils/apiConfig";
import axios from "axios";


Quill.register("modules/resize", QuillResizeImage);

const Size = Quill.import("attributors/style/size");
Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "32px",
  "48px",
];
Quill.register(Size, true);

const EditorPage = ({ blog, onDelete, onSave, onClose }) => {
  const [value, setValue] = useState("");
  const [toolbarPosition, setToolbarPosition] = useState({
    top: 0,
    left: 0,
    visible: false,
  });
  const [thumbnailHighRes, setThumbnailHighRes] = useState(null);
  const [thumbnailLowRes, setThumbnailLowRes] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const quillRef = useRef(null);

  useEffect(() => {
    if (blog) {
      setTitle(blog.blog_title || "");
      setDescription(blog.blog_description || "");
      setThumbnailHighRes(blog.blog_thumbnail_big_screen || null);
      setThumbnailLowRes(blog.blog_thumbnail_small_screen || null);
      setValue(blog.blog_html || "");
      setTags(blog.blog_tags ? blog.blog_tags.join(", ") : "");
    }
  }, [blog]);

  const handleSelectionChange = (range) => {
    const editor = quillRef.current?.getEditor();
    if (editor && range && range.length > 0) {
      const bounds = editor.getBounds(range.index);
      const toolbarHeight = 40;
      setToolbarPosition({
        top: bounds.top - toolbarHeight + 90,
        left: bounds.left,
        visible: true,
      });
    } else {
      setToolbarPosition((prev) => ({ ...prev, visible: false }));
    }
  };

  useEffect(() => {
    const quillInstance = quillRef.current?.getEditor();
    if (quillInstance) {
      quillInstance.on("selection-change", handleSelectionChange);
    }

    return () => {
      if (quillInstance) {
        quillInstance.off("selection-change", handleSelectionChange);
      }
    };
  }, []);

  const handleThumbnailUpload = (event, setThumbnail) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type === "image/webp" || file.type.startsWith("image/"))
    ) {
      const reader = new FileReader();
      reader.onload = (e) => setThumbnail(e.target.result);
      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid image file (JPEG, PNG, WebP, etc.).");
    }
  };

  const userName = localStorage.getItem("username");

  const handleSave = async () => {
    console.log("update",blog)
    const updatedBlog = {
      created_by: userName || "kartik",
      blog_html: value,
      blog_thumbnail_big_screen: thumbnailHighRes || "",
      blog_thumbnail_small_screen: thumbnailLowRes || "",
      blog_title: title,
      blog_description: description,
      tags: tags.split(",").map((tag) => tag.trim()),
    };

    console.log("payload",updatedBlog)

    try {
      const url =
        blog && blog.id
          ? `${backendHosts.ADMIN}${apiUrl.updateBlog}${blog?.blog_id}`
          : `${backendHosts.ADMIN}${apiUrl.createBlog}`;

      const method = blog && blog.id ? "put" : "post"

      const response = await axios[method](url, updatedBlog)

      // const response = await httpRequest({
      //   endPoint: url,
      //   method: blog && blog.id ? "put" : "post",
      //   instance: "instanceOne",
      //   requestBody: JSON.stringify(updatedBlog),
      // });

      console.log("Update and create res", response.data);

      onSave(response.data);
    } catch (error) {
      console.error("Error saving blog:", error);
    }
  };

  const handleDelete = async () => {
    if (blog && blog.blog_id) {
      try {

        const response = await axios.delete(`${backendHosts.ADMIN}${apiUrl.deleteBlog}${blog?.blog_id}`)
        // const response = await httpRequest({
        //   endPoint: `${backendHosts.ADMIN}${apiUrl.deleteBlog}${blog.blog_id}`,
        //   method: "delete",
        //   instance: "instanceOne",
        // });
        console.log(response.data);
        onDelete(blog.blog_id);
      } catch (error) {
        console.error("Error deleting blog:", error);
      }
    }
  };

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      quill.keyboard.addBinding({ key: " ", prefix: /^\d+\.$/ }, function () {
        quill.format("list", "ordered");
      });
    }
  }, []);

  const modules = {
    clipboard: {
      matchVisual: false,
    },
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        [
          {
            size: [
              "10px",
              "12px",
              "14px",
              "16px",
              "18px",
              "20px",
              "24px",
              "32px",
              "48px",
            ],
          },
        ],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "image", "video"],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    },
    resize: { locale: {} },
  };

  return (
    <Box
      sx={{
        background: "white",
        p: 4,
        position: "relative",
        backgroundColor: "#0B1420",
      }}
    >
      <Typography variant="h4" gutterBottom>
        Rich Text Editor
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "white" },
                "&:hover fieldset": { borderColor: "#F3D45E" },
                "&.Mui-focused fieldset": { borderColor: "white" },
              },
              "& .MuiInputLabel-root": { color: "white" },
              "& .MuiInputBase-input": { color: "white" },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "white" },
                "&:hover fieldset": { borderColor: "#F3D45E" },
                "&.Mui-focused fieldset": { borderColor: "white" },
              },
              "& .MuiInputLabel-root": { color: "white" },
              "& .MuiInputBase-input": { color: "white" },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Tags (comma-separated)"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "white" },
                "&:hover fieldset": { borderColor: "#F3D45E" },
                "&.Mui-focused fieldset": { borderColor: "white" },
              },
              "& .MuiInputLabel-root": { color: "white" },
              "& .MuiInputBase-input": { color: "white" },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" component="label">
            Upload Thumbnail For Big Screens
            <input
              type="file"
              hidden
              onChange={(e) => handleThumbnailUpload(e, setThumbnailHighRes)}
            />
          </Button>
        </Grid>
        {thumbnailHighRes && (
          <Grid item xs={12}>
            <img
              src={thumbnailHighRes}
              alt="High-Res Thumbnail"
              style={{
                width: "100%",
                height: "auto",
                marginBottom: "10px",
              }}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Button variant="contained" component="label">
            Upload Thumbnail For Small Screens
            <input
              type="file"
              hidden
              onChange={(e) => handleThumbnailUpload(e, setThumbnailLowRes)}
            />
          </Button>
        </Grid>
        {thumbnailLowRes && (
          <Grid item xs={12}>
            <img
              src={thumbnailLowRes}
              alt="Low-Res Thumbnail"
              style={{
                width: "",
                height: "auto",
                marginBottom: "10px",
              }}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={value}
            onChange={setValue}
            modules={modules}
            formats={[
              "header",
              "size",
              "bold",
              "italic",
              "underline",
              "strike",
              "blockquote",
              "list",
              "bullet",
              "indent",
              "link",
              "image",
              "video",
              "align",
              "resize",
              "color",
              "background",
            ]}
            style={{ fontFamily: "Cardiuma-M" }}
          />
        </Grid>

        <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" onClick={handleSave}>
            {blog && blog.blog_id ? "Update" : "Create"}
          </Button>
          {blog && blog.blog_id && (
            <Button variant="contained" color="error" onClick={handleDelete}>
              Delete
            </Button>
          )}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#0B1420",
              border: "1px solid #ccc",
              p: 2,
              borderRadius: "4px",
              minHeight: "200px",
              overflowY: "auto",
              fontFamily: "Cardiuma-M",
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ color: "white" }}>
              Preview
            </Typography>
            <div
              dangerouslySetInnerHTML={{
                __html: `
            <style>
                    ol {
                      counter-reset: item;
                      font-weight: 900 !important;
                    }
                    ol li {
                      list-style-type: none;
                      font-weight: 900 !important;
                    }
                    ol li:before {
                      counter-increment: item;
                      content: counter(item) ". ";
                      font-weight: bold;
                      font-weight: 900 !important;
                    }
                    h1, h2, h3 {
                      scroll-margin-top: 100px;
                    }
                    /* Exclude links from these rules */
                    h1, h2, h3, strong:not(a strong), b:not(a b) {
                      font-weight: 900 !important;
                      font-family: 'cardiuma-Bold' !important;
                      color: #FFFFFF !important;
                    }
                    /* Keep bold styling but don't force color */
                    b:not(a b) {
                      font-weight: 900 !important;
                      font-family: 'cardiuma-Bold' !important;
                    }
                    p, div, li {
                      font-family: 'cardiuma-regular' !important;
                      color: #999999 !important;
                    }
                    /* Italic styles that won't affect links */
                    i:not(a i), em:not(a em) {
                      font-family: 'cardiuma-regular' !important;
                      color: #999999 !important;
                      font-style: italic !important;
                    }
                    /* Adjust font sizes for medium screens (601px to 900px) */
                    @media (max-width: 900px) {
                      h1 { font-size: 1.75rem; } /* 28px */
                      h2 { font-size: 1.5rem; } /* 24px */
                      h3 { font-size: 1.25rem; } /* 20px */
                    }

                    /* Adjust font sizes for small screens (600px and below) */
                    @media (max-width: 600px) {
                      h1 { font-size: 1.5rem; } /* 24px */
                      h2 { font-size: 1.25rem; } /* 20px */
                      h3 { font-size: 1rem; } /* 16px */
                    }
                  </style>
              ${value}`,
              }}
            />
          </Box>
        </Grid>
        <DevicePreview value={value} />
      </Grid>
    </Box>
  );
};

export default EditorPage;
